import { render, staticRenderFns } from "./aboutContact.vue?vue&type=template&id=2a8614c2&scoped=true&"
import script from "./aboutContact.vue?vue&type=script&lang=js&"
export * from "./aboutContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8614c2",
  null
  
)

export default component.exports